/*eslint-disable */

import { bus } from '@/main';
import { mapGetters } from 'vuex';
import removeQBankPopup from '../q-bank-delete-popup/';

export default {
  name: 'q-bank-list-page',
  components: {
    'remove-q-bank-popup' : removeQBankPopup
  },
  props: [],
  data () {
    return {
      qBankListData:null,
      qBankListRslts:[],
      removeQbankPopupState:false,
      removeQbankId:''
    }
  },
  computed: {
    ...mapGetters([
      'qBankListGetter',
    ]),
    getCandidateListFun(){
     this.qBankListData = this.$store.getters.qBankListGetter.data
     return 
    },
    setInintialState(){
      if(this.qBankListData){
        this.qBankListRslts = this.qBankListData.results;
      }
      return;
    }
  },
  mounted () {
    this.getCandidateListFun;
    this.setInintialState;
    bus.$on('removeQbankPopupStateBus', (data) => {
      this.removeQbankPopupState = data
    })
  },
  methods: {
    removeCandidateInfoMethod(id){
      this.removeQbankId = id
      this.removeQbankPopupState = true
      document.body.classList.add('body_right_scroll_remove')
    }
  },
  watch: {
    getCandidateListFun(){
      return this.$store.getters.qBankListGetter; 
    },
    setInintialState(){
      if(this.qBankListData){
        this.qBankListRslts = this.qBankListData.results;
      }
      return;
    }
  },
}